<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">201910281817548964791</div>
        </div>
        <div class="complaintObject border_bottom">
          <div class="left">被投诉对象</div>
          <div class="right">昆明康康旅行社</div>
        </div>
        <div class="complaintClassification border_bottom">
          <div class="left">投诉分类</div>
          <div class="right">
            <span>请选择 ></span>
          </div>
        </div>
        <div class="objectofcomplaint border_bottom">
          <div class="left">被投诉对象</div>
          <div class="right">
            <span>请选择 ></span>
          </div>
        </div>
        <div class="complaint border_bottom">
          <div class="left">投诉问题</div>
          <div class="right">
            <span>请选择 ></span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">具体情形</div>
          <div class="right">
            <span>请选择 ></span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">告知行政部门</div>
          <div class="right">
            <span>请选择 ></span>
          </div>
        </div>
        <div class="whetherApplyAplitting border_bottom">
          <div class="left">是否申请拆单</div>
          <div class="right">
            <van-RadioGroup
              v-model="isSplit"
              style="display:flex;margin-top:15px;justify-content:space-around"
            >
              <van-Radio name="1">是</van-Radio>
              <van-Radio name="2">否</van-Radio>
            </van-RadioGroup>
          </div>
        </div>
        <div class="whetherToSue border_bottom">
          <div class="left">是否诉转案</div>
          <div class="right">
            <van-RadioGroup
              v-model="isCase"
              style="display:flex;margin-top:15px;justify-content:space-around"
            >
              <van-Radio name="1">是</van-Radio>
              <van-Radio name="0">否</van-Radio>
            </van-RadioGroup>
          </div>
        </div>
      </div>
      <!-- <div class="remark border_bottom" v-show="isCaseFlag">
        <div class="titleName">申请拆单原因</div>
        <div class="notAccepted">
          <van-field placeholder="请填写申请拆单原因..." type="textarea" maxlength="50" v-model="splitReason" />
        </div>
      </div>
      <div class="companyName border_bottom" v-show="!isCaseFlag">
        <van-field placeholder="请输入企业名称" v-model="companyArray" />
      </div> -->
      <div class="emergencyLevel border_bottom">
        <van-field value="添加办结时限、紧急程度、工单分类" left-icon="contact" disabled />
      </div>
      <div class="urgent">
        <div class="limitedProcesseTime border_bottom">
          <div class="left">办结时限：</div>
          <div class="right">
            <van-field type="number" maxlength="2" input-align="center" style="width:40px" v-model="hour" />
            <span>小时</span>
            <van-field type="number" maxlength="2" input-align="center" style="width:40px"  v-model="minite" />
            <span>分钟</span>
          </div>
        </div>
        <div class="emergencyLabel border_bottom">
          <div class="left">紧急程度</div>
          <div class="right">
            <div class="general" :class="{tabColor:generals===true}" @click="general">一般</div>
            <div class="heavier" :class="{tabColor:heaviers===true}" @click="heavier">较重</div>
            <div class="serious" :class="{tabColor:seriouss===true}" @click="serious">严重</div>
          </div>
        </div>
        <div class="complaintClass">
          <div class="left">工单分类</div>
          <div class="right">
            <div class="Complaint" :class="{tabColor:Complaints===true}" @click="Complaint">投诉</div>
            <div class="Suggest" :class="{tabColor:Suggests===true}" @click="Suggest">建议</div>
            <div style="width:50px;height:0;"></div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary">确认</van-button>
        </div>
        <div class="back">
          <van-button plain type="default" color="#979595">返回</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaint';
    export default {
        data () {
            return {
                radio: '1',
                radio1: '1',
                tab: ['一般', '较重', '严重'],
                generals: true,
                heaviers: false,
                seriouss: false,
                Complaints: true,
                Suggests: false,

                isSplit: '2', // 是否申请拆单
                isCase: '0', // 是否诉转案
                isCaseFlag: false,
                emergency: '', // 紧急程度标签
                category: '' // 投诉分类
            };
        },
        created () {

        },
        watch: {
            radio1 (val) {
                // console.log(123, this.radio)
                this.complaintTarget = val.name;
            },
            complaintVal (val) {
                // console.log(333, val)
                if (val !== '') {
                    this.parms.pid = val;
                    this.complaintObjVal = ''
                    this.complaintObj = ''
                    this.complaintsVal = ''
                    this.complaints = ''
                    this.situation = ''
                    this.situationVal = ''
                    this.actions2 = []
                    this.actions3 = []
                    this.actions4 = []
                }
            },
            complaintObjVal (val) {
                if (val !== '') {
                    this.parms.pid = val;
                    this.complaintsVal = ''
                    this.complaints = ''
                    this.situation = ''
                    this.situationVal = ''
                    this.actions3 = []
                    this.actions4 = []
                }
            },
            complaintsVal (val) {
                if (val !== '') {
                    this.parms.pid = val;
                    this.situation = ''
                    this.situationVal = ''
                    this.actions4 = []
                }
            }
        },
        methods: {
            general () {
                this.generals = true;
                this.heaviers = false;
                this.seriouss = false;
                this.emergency = 7
            },
            heavier () {
                this.generals = false;
                this.heaviers = true;
                this.seriouss = false;
                this.emergency = 8
            },
            serious () {
                this.generals = false;
                this.heaviers = false;
                this.seriouss = true;
                this.emergency = 9
            },
            Complaint () {
                this.Complaints = true;
                this.Suggests = false;
                this.category = 5
            },
            Suggest () {
                this.Complaints = false;
                this.Suggests = true;
                this.category = 6
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation,
      .informAdministration,
      .whetherApplyAplitting,
      .whetherToSue {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation,
      .informAdministration {
        .right {
          color: #ddd;
        }
      }
      .complaintTarget_class {
        color: #000000;
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .urgent {
      width: 100%;
      font-size: 14px;
      .limitedProcesseTime {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          width: 55%;
          margin-left: 15px;
          display: flex;
          .van-field {
            border-bottom: 1px solid #ccc;
            height: 30px;
            margin-top: 10px;
            padding: 0;
          }
          span {
            color: #aaa;
          }
        }
      }
      .emergencyLabel,
      .complaintClass {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          display: flex;
          width: 50%;
          justify-content: space-between;
          div {
            width: 50px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            background-color: #fff;
            color: #aaa;
          }
          .tabColor {
            background-color: #07c160;
            color: #fff;
          }
        }
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
